module.exports = __webpack_public_path__ + "static/img/model-bg12.1a6bb1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg12.jpg
// module id = 3P2E
// module chunks = 0